import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { formatMinorUnits } from "../../shared/money";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatMoney(minor: number, currency: string, locale?: string): string {
  return formatMinorUnits(minor, currency, locale);
}

export function formatDateTime(d: string | Date, tz?: string): string {
  const date = typeof d === "string" ? new Date(d) : d;
  if (Number.isNaN(date.getTime())) return "";
  try {
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: "medium",
      timeStyle: "short",
      timeZone: tz,
    }).format(date);
  } catch {
    return date.toISOString();
  }
}
